import { Control, useWatch } from 'react-hook-form'

import { Money } from '@/components/ds'
import { cn } from '@/lib/utils'
import { Currency } from '@/types/Currency'

import { calculateTotals } from '../calculateTotals'
import { DocumentFormValues } from '../DocumentForm'

interface TotalsProps {
  control: Control<DocumentFormValues>
  currencies?: Currency[]
  isVatPayer: boolean
}

const Stat = ({ label, children, className }: { label: string; children: React.ReactNode; className?: string }) => (
  <div className={cn('grid min-w-0 gap-0.5', className)}>
    <span className="text-xs text-muted-foreground">{label}</span>
    {children}
  </div>
)

/** Kompaktní součty do spodní lišty editoru: bez DPH, DPH a tučně částka k úhradě. */
export const Totals = ({ control, currencies, isVatPayer }: TotalsProps) => {
  const items = useWatch({ control, name: 'items' }) ?? []
  const currencyCode = useWatch({ control, name: 'settings.currency' }) ?? 'CZK'
  const currency = currencies?.find((c) => c.code === currencyCode)?.code ?? currencyCode

  const { totalWithoutTaxes, tax, total } = calculateTotals(items)

  return (
    <div className="flex min-w-0 flex-wrap items-end gap-x-6 gap-y-1">
      {isVatPayer && (
        <>
          <Stat label="Celkem bez DPH" className="hidden sm:grid">
            <Money amount={totalWithoutTaxes} minor={false} currency={currency} className="h-7 font-normal" />
          </Stat>
          <Stat label="DPH" className="hidden sm:grid">
            <Money amount={tax} minor={false} currency={currency} className="h-7 font-normal" />
          </Stat>
        </>
      )}
      <Stat label="K úhradě">
        <Money
          amount={isVatPayer ? total : totalWithoutTaxes}
          minor={false}
          currency={currency}
          size="lg"
          className="h-7 font-semibold leading-7"
          animate
        />
      </Stat>
    </div>
  )
}
